/**
 * Configuration taken from https://gist.github.com/Chocksy/e9b2cdd4afc2aadc7989762c4b8b495a recommended by Sentry to fitler out unwanted error reports
 */
const ignoreErrors = [
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // Generic error code from errors outside the security sandbox
  // You can delete this if using raven.js > 1.0, which ignores these automatically.
  "Script error.",
  // Network errors such as going offline or being blocked by a proxy
  "Failed to fetch",
  // Error generated by a bug in auto-fill library from browser
  // https://github.com/getsentry/sentry/issues/5267
  /Blocked a frame with origin/,
  // Probably some facebook / GTM corporate site script, not crashing the app, ignored
  "fbq is not defined",
  "Can't find variable: fbq",
  // LaunchDarkly feature flag system 3rd party errors, not in CD code
  // eslint-disable-next-line quotes
  'Expected application/json content type but got ""',
  "network error (Error)",
  "Incorrect email or password",
  "Request failed with status code 401",
  // common third-party errors caught by Sentry
  /Amplitude SDK/,
  /@emotion\/react/,
  /Material-UI/,
  /Button click detected/,
  /Websocket close was unclean/,
  /Fingerprint/,
  /LaunchDarkly/,
  /rudderlabs/,
  /react-i18next/,
  /Hotjar/,
];

const denyUrls = [
  // Google Adsense
  /pagead\/js/i,
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // Recaptcha errors
  /recaptcha\//i,
];

export const BaseConfig = {
  ignoreErrors,
  denyUrls,
};
